/* eslint-disable import/first */
import React from 'react';
import { Grid, Divider, Typography, Button, Stepper, Step, StepLabel } from '@material-ui/core';

import { FormattedMessage, useIntl } from 'react-intl';
import { Redux } from 'spwa-ui-library';
const { useSelector } = Redux;
import { useNavigate } from '@reach/router';
import format from 'date-fns/format';
import ClassNames from 'classnames';
import ready from './images/status.svg';
import beingPrepare from './images/prepared.svg';
import ontheWay from './images/onway.svg';
import delivered from './images/delivered.svg';
import completed from './images/orderComplete.svg';
import pickup from './images/readypickup.svg';
import dineinIco from './images/dine-in.svg';
import dineInReady from './images/dineInReady.svg';
import driveIcon from './images/drive-thru.svg';
import beingPreparedPending from './images/prepared.svg';
import css from './index.module.scss';
import CustomStepper from './CustomStepper';

const OrderConfirm = ({ orderInfo, orderDetail, status, labels }) => {
  const navigate = useNavigate();
  const intl = useIntl();
  const profile = useSelector((state) => state.profile);
  const allProfiles = profile?.data?.data;

  if (labels.length) {
    return '';
  }

  // const orderState = {
  //   PENDING: 'ORDER_PENDING',
  //   PREPARED: 'ORDER_PREPARED',
  //   ON_THE_WAY: 'ORDER_ON_THE_WAY',
  //   DELIVERED: 'ORDER_DELIVERED',
  //   CONFIRMED: 'ORDER_CONFIRMED',
  //   BEING_PREPARED: 'ORDER_BEING_PREPARED',
  //   COMPLETE_FOR_PICKUP: 'ORDER_COMPLETE_FOR_PICKUP',
  //   COMPLETE_FOR_DRIVE_THRU: 'ORDER_COMPLETE_FOR_DRIVE_THRU',
  //   COMPLETE_FOR_DINE_IN: 'ORDER_COMPLETE_FOR_DINE_IN',
  // };
  // eslint:fix orderState is defined a value but is never used
  // const labelVeriable = `ORDER_${status}`;
  // const varn = labels[labelVeriable]?.description;

  const statusCode = orderDetail?.sdmOrderStatus || 2;
  const logs = orderDetail?.sdmOrderStatusLogs || [];
  const dateTime = logs.find((entry) => entry.sdmOrderStatus === statusCode);
  if (status === 'CANCELED' || status === 'FAILURE') {
    navigate(`/${intl.locale}/thank-you/${orderInfo._id}`, { replace: true });
  }

  const renderSecondStep = () => {
    switch (status) {
      case 'READY':
      case 'ON_THE_WAY':
        return (
          <>
            <Typography>
              <FormattedMessage id={'trackOrder_foodReady'} defaultMessage="Food is Ready" />
            </Typography>
            <Grid>
              <Button className={css.doneButton}>
                <FormattedMessage id="trackorder_done" defaultMessage="Done" />
              </Button>
            </Grid>
          </>
        );
      case 'BEING_PREPARED':
        return (
          <>
            <Typography>
              <FormattedMessage id="order_being_prepared" defaultMessage="Being Prepared" />
            </Typography>
            <Grid className={css.orderDesc}>
              <Typography>
                <FormattedMessage
                  id="trackorder_foodprepared"
                  defaultMessage="The food is being prepared."
                />
              </Typography>
            </Grid>
          </>
        );
      case 'CONFIRMED':
        return (
          <>
            <Typography>
              <FormattedMessage id="trackOrder_beingPrepared" defaultMessage="Being Prepared" />
            </Typography>
            <Grid>
              <Button className={css.laterButton}>
                <FormattedMessage id="trackorder_later" defaultMessage="later" />
              </Button>
            </Grid>
          </>
        );
      default:
        return '';
    }
  };

  return (
    <Grid className={css.orderConfirmRoot}>
      {status !== 'DELIVERED' ? (
        <Grid>
          <Grid
            className={ClassNames(css.orderConfirmed, {
              [css.orderConfirmedInProgress]: status !== 'DELIVERED',
            })}
          >
            <Grid className={css.icon}>
              <img src={ready} alt="" />
            </Grid>
            <Grid className={css.content}>
              {status === 'PENDING' ? (
                <React.Fragment>
                  <Typography>
                    <FormattedMessage id="trackorder_orderplaced" defaultMessage="Order Placed" />
                  </Typography>
                  <Grid className={css.orderDesc}>
                    <Typography>
                      <FormattedMessage
                        id="trackorder_foodprepared"
                        defaultMessage="The food is being prepared."
                      />
                    </Typography>
                  </Grid>
                </React.Fragment>
              ) : (
                <React.Fragment>
                  <Typography>
                    <FormattedMessage
                      id="trackorder_orderconfirmed"
                      defaultMessage="Order Confirmed"
                    />
                  </Typography>
                  <Grid>
                    <Button className={css.doneButton}>
                      <FormattedMessage id="trackorder_done" defaultMessage="Done" />
                    </Button>
                  </Grid>
                </React.Fragment>
              )}
            </Grid>
          </Grid>
          <Divider className={css.divider} />
          <Grid
            className={ClassNames(
              css.orderConfirmed,
              {
                [css.disabled]: status === 'PENDING' || status === 'CONFIRMED',
              },
              {
                [css.orderConfirmedInProgress]: status !== 'DELIVERED',
              }
            )}
          >
            <Grid className={css.icon}>
              <img
                src={
                  status === 'PENDING' || status === 'CONFIRMED'
                    ? beingPreparedPending
                    : beingPrepare
                }
                alt=""
              />
            </Grid>
            <Grid className={css.content}>{renderSecondStep()}</Grid>
          </Grid>
          <Divider className={css.divider} />
          <Grid
            className={ClassNames(
              css.orderConfirmed,
              { [css.disabled]: status !== 'ON_THE_WAY' },
              {
                [css.orderConfirmedInProgress]: status !== 'DELIVERED',
              }
            )}
          >
            <Grid className={css.icon}>
              {orderDetail?.orderType === 'DELIVERY' && (
                <img src={status === 'ON_THE_WAY' ? ontheWay : ontheWay} alt="" />
              )}
              {orderDetail?.orderType === 'PICKUP' &&
                orderDetail?.address.addressSubType === 'STORE' && (
                  <img src={status === 'ON_THE_WAY' ? pickup : pickup} alt="" />
                )}
              {(orderDetail?.address.addressSubType === 'CARHOP' ||
                orderInfo?.address?.addressSubType === 'CURBSIDE') &&
                orderDetail?.orderType === 'PICKUP' && (
                  <img src={status === 'ON_THE_WAY' ? ontheWay : ontheWay} alt="" />
                )}
              {orderDetail?.orderType === 'DINEIN' && (
                <img src={status === 'ON_THE_WAY' ? dineInReady : dineInReady} alt="" />
              )}
              {orderDetail?.orderType === 'DRIVETHRU' && (
                <img src={status === 'ON_THE_WAY' ? ontheWay : driveIcon} alt="" />
              )}
            </Grid>

            <Grid className={css.content}>
              <Typography>
                {orderDetail?.address?.addressSubType === 'DELIVERY' && (
                  <FormattedMessage id="trackorder_ontheway" defaultMessage="On the way" />
                )}
                {orderDetail?.address?.addressSubType === 'STORE' && (
                  <FormattedMessage id="trackorder_pickup" defaultMessage="Ready for Pickup" />
                )}
                {/* i have changed as per in super app */}
                {orderDetail?.address?.addressSubType === 'CARHOP' && (
                  <FormattedMessage id="trackorder_ontheway" defaultMessage="On the way" />
                )}
                {orderDetail?.address?.addressSubType === 'DINEIN' && (
                  <FormattedMessage id="trackorder_dinein" defaultMessage="Ready for Dine-in" />
                )}
                {orderDetail?.address?.addressSubType === 'DRIVETHRU' && (
                  <FormattedMessage
                    id="trackorder_drivethru"
                    defaultMessage="Ready for Drive-Thru"
                  />
                )}
              </Typography>
              {status !== 'ON_THE_WAY' && (
                <Grid>
                  <Button className={css.laterButton}>
                    <FormattedMessage id="next" defaultMessage="Next" />
                  </Button>
                </Grid>
              )}
              {status === 'ON_THE_WAY' && (
                <Grid className={css.orderDesc}>
                  <Typography>
                    {orderDetail?.orderType === 'DELIVERY' ? (
                      <FormattedMessage
                        id="trackorder_ontheway_description"
                        defaultMessage="Our person is on his way to delivery your delicious food"
                      />
                    ) : (
                      <FormattedMessage
                        id="trackorder_pickup_discription"
                        defaultMessage="Your delicious food is ready"
                      />
                    )}
                  </Typography>
                </Grid>
              )}
            </Grid>
          </Grid>
          <CustomStepper status={status} />
        </Grid>
      ) : (
        <Grid>
          <Grid className={css.orderConfirmed}>
            <div className={css.orderDeliveredWrap}>
              <div className={css.deliverdWrap}>
                <Grid>
                  <img src={completed} alt="" />
                </Grid>
                <Grid className={css.centerText}>
                  <Typography className={css.headerText}>
                    <FormattedMessage
                      id="order_delivered"
                      defaultMessage="Your Order is Complete"
                    />
                  </Typography>
                  <Typography className={css.descText}>
                    {orderDetail?.address?.addressSubType === 'DELIVERY' && (
                      <FormattedMessage id="delivery_on" defaultMessage="Delivery on" />
                    )}
                    {orderDetail?.address?.addressSubType === 'STORE' && (
                      <FormattedMessage id="picked_on" defaultMessage="Pickup up on" />
                    )}
                    {orderDetail?.address?.addressSubType === 'CARHOP' && (
                      <FormattedMessage
                        id="curbside_on"
                        defaultMessage="Curbside order completed up on"
                      />
                    )}
                    {orderDetail?.address?.addressSubType === 'DINEIN' && (
                      <FormattedMessage
                        id="dinein_on"
                        defaultMessage="Dine in order completed up on"
                      />
                    )}
                    {dateTime && format(dateTime?.updatedAt, 'dd LLL, yyyy')}{' '}
                    <FormattedMessage id="to" defaultMessage="to" /> {allProfiles?.[0]?.name}
                  </Typography>
                  <Button className={css.doneBtnStyle}>
                    <FormattedMessage id="trackorder_done" defaultMessage="Done" />
                  </Button>
                </Grid>
              </div>
              <div>
                <Grid className={css.deliveredImg}>
                  <img src={delivered} alt="" />
                </Grid>
              </div>
            </div>
          </Grid>
          {/* <Divider className={css.divider} /> */}
        </Grid>
      )}
    </Grid>
  );
};

export default OrderConfirm;
